export const GamePinBar = ({ pin }) => {
  if (!pin) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-40 flex justify-center pointer-events-none pb-3">
      <div
        className="pointer-events-auto flex items-center gap-2.5 bg-black/45 backdrop-blur-md rounded-full pl-4 pr-5 py-2 text-white shadow-lg border border-white/15"
        data-testid="game-pin-bar"
      >
        <span className="text-[11px] uppercase tracking-widest text-white/60 font-semibold">PIN do jogo</span>
        <span className="font-heading font-black text-lg tracking-[0.25em] tabular-nums" data-testid="game-pin-bar-value">{pin}</span>
      </div>
    </div>
  );
};

export default GamePinBar;
